import { render, staticRenderFns } from "./feedbackResult.vue?vue&type=template&id=59ac468e&scoped=true"
import script from "./feedbackResult.vue?vue&type=script&lang=js"
export * from "./feedbackResult.vue?vue&type=script&lang=js"
import style0 from "./feedbackResult.vue?vue&type=style&index=0&id=59ac468e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ac468e",
  null
  
)

export default component.exports